import { render, staticRenderFns } from "./StandardReport.vue?vue&type=template&id=2afb4893&scoped=true&"
import script from "./StandardReport.vue?vue&type=script&lang=js&"
export * from "./StandardReport.vue?vue&type=script&lang=js&"
import style0 from "./StandardReport.vue?vue&type=style&index=0&id=2afb4893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb4893",
  null
  
)

export default component.exports